<script>
/**
 * Descripción: Contenedor de la aplicación
 *
 * @displayName App
 */

const TheNotificationContainer = () =>
  import('@/components/core/alerts/TheNotificationContainer.vue');

export default {
  name: 'App',

  components: {
    TheNotificationContainer
  }
};
</script>

<template>
  <v-app light>
    <TheNotificationContainer />
    <router-view />
  </v-app>
</template>

<style>
html {
  overflow-y: auto !important;
}

.theme--light.v-data-table tbody tr.v-data-table__selected {
  color: #ffffff;
  background: #2c3e50 !important;
}

.v-data-table .v-data-table__mobile-table-row {
  display: initial;
  color: black !important;
}
</style>
